import { render, staticRenderFns } from "./PlayingCard.vue?vue&type=template&id=3b42ad5e&"
import script from "./PlayingCard.vue?vue&type=script&lang=ts&"
export * from "./PlayingCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports